import { render } from "./AddSequenceView.vue?vue&type=template&id=1bdffbac&scoped=true"
import script from "./AddSequenceView.vue?vue&type=script&lang=js"
export * from "./AddSequenceView.vue?vue&type=script&lang=js"

import "./AddSequenceView.vue?vue&type=style&index=0&id=1bdffbac&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdffbac"]])

export default __exports__